import { applyOauthApi } from './oauthApi';

export default [applyOauthApi];
